/* eslint-disable camelcase */
import React, { useState } from 'react';
import Lodash from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Formik, Field } from 'formik';
import Box from '@material-ui/core/Box';
import {
  PlnDropdown,
  PlnInput,
} from '../../Components/Input';
import Copyright from '../Copyright/Copyright';
import reporteResultados from '../../Core/Api/reporteResultados';
import {
  useProvincias,
  getCantonsByProvince,
  getDistritoByTwo,
} from '../../Core/Api/locationApi';
import MacroList from '../MacroList/MacroList';

const useStyles = makeStyles(() => ({
  btnAdd: {
    float: 'right',
    width: 150,
    height: 30,
    marginTop: 5,
  },
  container: {
    maxWidth: 1600,
    paddingTop: 40,
    paddingBottom: 40,
  },
  paper: {
    padding: 20,
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

function createData(_data) {
  return {
    province: _data.des_nombre_p,
    canton: _data.des_nombre_c,
    distrito: _data.des_nombre_d,
    junta: _data.cod_junta,
    res001: _data.res_001,
    res002: _data.res_002,
    res003: _data.res_003,
    res004: _data.res_004,
    // res005: _data.res_005,
    validos: _data.validos,
    blancos: _data.res_vb,
    nulos: _data.res_vn,
    recibidos: _data.recibidos,
  };
}

function createFooterData(_data) {
  return {
    province: _data.provincia,
    canton: _data.canton,
    distrito: _data.distrito,
    junta: _data.junta,
    res001: _data.ARC,
    res002: _data.GJS,
    res003: _data.MTD,
    res004: _data.CDR,
    // res005: _data.RTC,
    validos: _data.Validos,
    blancos: _data.Blancos,
    nulos: _data.Nulos,
    recibidos: _data.Recibidos,
  };
}

const EVConvencionInterna = () => {
  const classes = useStyles();
  const { data } = useProvincias();

  const [showResults, setShowResults] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Opciones Seleccionadas
  const [sProvincia, setSProvincia] = useState(9);
  const [sCanton, setSCanton] = useState(999);
  // eslint-disable-next-line no-unused-vars
  const [sDistrito, setSDistrito] = useState(999);

  const [isDataEmpty, setDataEmpty] = useState(false);
  const [filteredItems, setFilteredItems] = useState([
    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
  ]); // used for filtering
  const [footerData, setFooterData] = useState([
    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
  ]); // used for filtering
  const [currentDate, setCurrentDate] = useState(''); // used for filtering

  // Lista de: Provincias, Cantones, Distritos y Movimientos
  const [initialValues] = useState(
    Lodash.get(data, ['initValues'], {
      provincia: 9,
      canton: 999,
      distrito: 999,
      jrv: '',
    }),
  );

  const provincias = Lodash.get(
    data,
    ['frmOptions'],
    [
      {
        itemLabel: '- SELECCIONE LA PROVINCIA -',
        value: 9,
      },
    ],
  );

  const [cantones, setCantones] = useState([
    { itemLabel: '- SELECCIONE EL CANTÓN -', value: 999 },
  ]);
  const [distritos, setDistritos] = useState([
    { itemLabel: '- SELECCIONE EL DISTRITO -', value: 999 },
  ]);

  const heads = [
    {
      name: 'Provincia',
    },
    {
      name: 'Cantón',
    },
    {
      name: 'Distrito',
    },
    {
      name: 'Junta',
    },
    {
      name: 'ARC',
    },
    {
      name: 'GJS',
    },
    {
      name: 'MTD',
    },
    {
      name: 'CDR',
    },
    {
      name: 'Válidos',
    },
    {
      name: 'Blancos',
    },
    {
      name: 'Nulos',
    },
    {
      name: 'Recibidos',
    },
  ];

  const getTimeStamp = someDate => {
    const now = new Date(someDate);
    // console.log(now.getHours());
    return `${now.getHours()}:${
      now.getMinutes() < 10
        ? `0${now.getMinutes()}`
        : now.getMinutes()
    }`;
  };

  // Date Options
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    // timeZone: 'UTC',
  };

  const formatDate = date => {
    const dateParts = date.split('/');
    const month = dateParts[1];
    const day = dateParts[0];
    const year = dateParts[2];

    return [day, month, year].join('/');
  };

  const validationSchema = Yup.object({});

  /**
   * List all actions that a user can do for each item in the list
   */
  const setActions = () => {
    const actions = [];

    return actions;
  };

  const setProvincia = p => {
    setCantones([
      {
        itemLabel: '- SELECCIONE EL CANTÓN-',
        value: 999,
      },
    ]);
    setDistritos([
      {
        itemLabel: '- SELECCIONE EL DISTRITO-',
        value: 999,
      },
    ]);

    initialValues.provincia = p;
    initialValues.canton = 999;
    initialValues.distrito = 999;
    initialValues.jrv = '';
    if (p !== 9) {
      getCantonsByProvince(p).then(result => {
        if (result.status === 200) {
          const cantonsList = Lodash.get(result, [
            'data',
            'response',
          ]);

          const clist = cantonsList.map(
            ({ cod_canton, des_nombre_c }) => {
              return {
                itemLabel: des_nombre_c,
                value: cod_canton,
              };
            },
          );
          clist.unshift({
            itemLabel: '- SELECCIONE EL CANTÓN-',
            value: 999,
          });

          setSProvincia(
            Lodash.find(provincias, {
              value: p,
            }),
          );
          setCantones(clist);
        }
      });
    }
  };

  const setCanton = c => {
    initialValues.distrito = 999;
    initialValues.provincia = sProvincia.value;
    initialValues.canton = c;
    initialValues.jrv = '';

    if (c !== 999) {
      getDistritoByTwo(sProvincia.value, c).then(result => {
        if (result.status === 200) {
          const distritosList = Lodash.get(result, [
            'data',
            'response',
          ]);

          const dlist = distritosList.map(
            ({ cod_distrito, des_nombre_d }) => {
              return {
                itemLabel: des_nombre_d,
                value: cod_distrito,
              };
            },
          );

          dlist.unshift({
            itemLabel: '- SELECCIONE EL DISTRITO-',
            value: 999,
          });

          setSCanton(
            Lodash.find(cantones, {
              value: c,
            }),
          );

          setDistritos(dlist);
        }
      });
    } else {
      setDistritos([
        {
          itemLabel: '- SELECCIONE EL DISTRITO-',
          value: 999,
        },
      ]);
    }
  };

  const getJRV = async _codDistr => {
    initialValues.provincia = sProvincia.value;
    initialValues.canton = sCanton.value;
    initialValues.distrito = _codDistr;
    initialValues.jrv = '';
    const currentDistr = parseInt(_codDistr, 10);

    if (currentDistr > 0 && currentDistr !== 999) {
      // const { codProvincia, codCanton } = memberInfo;
      setSDistrito(
        Lodash.find(distritos, {
          value: _codDistr,
        }),
      );
    }
  };

  /*
  const getJRVSelected = _jrv => {
    const currentJRV = parseInt(_jrv, 10);

    if (currentJRV > 0 && currentJRV !== 999) {
      // console.log(currentJRV);
    }
  };
 */

  const renderForm = () => {
    return (
      <div className={classes.boxForm}>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <h4>Provincia</h4>
            <Field
              name="provincia"
              data={provincias}
              component={PlnDropdown}
              onChange={provincia =>
                setProvincia(provincia)
              }
            />
          </Grid>
          <Grid item xs={3}>
            <h4>Cantón</h4>
            <Field
              name="canton"
              data={cantones}
              component={PlnDropdown}
              onChange={canton => setCanton(canton)}
            />
          </Grid>
          <Grid item xs={3}>
            <h4>Distrito </h4>
            <Field
              name="distrito"
              data={distritos}
              component={PlnDropdown}
              onChange={dist => {
                getJRV(dist);
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <h4>Junta</h4>
            <Field
              mask="999999999"
              name="jrv"
              component={PlnInput}
              type="text"
              style={{ marginTop: 10, height: 60 }}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  // eslint-disable-next-line no-unused-vars
  const doSearch = values => () => {
    setShowResults(true);
    setIsLoading(true);

    // eslint-disable-next-line no-shadow
    const { canton, distrito, jrv, provincia } = values;
    const codProvincia = provincia === 9 ? -1 : provincia;
    const codCanton = canton === 999 ? -1 : canton;
    const codDistrito = distrito === 999 ? -1 : distrito;
    const codJrv = jrv === '' ? -1 : parseInt(jrv, 10);
    reporteResultados
      .getReporteResultados001(
        codProvincia,
        codCanton,
        codDistrito,
        codJrv,
      )
      .then(result => {
        setIsLoading(false);
        const info = Lodash.get(
          result,
          ['data', 'response'],
          [],
        );
        const footerInfo = Lodash.get(
          result,
          ['data', 'footer'],
          [],
        );
        const currDate = Lodash.get(
          result,
          ['data', 'currentDate'],
          [],
        );

        const cDate = formatDate(
          new Date(currDate).toLocaleDateString(
            'es-ES',
            options,
          ),
        );
        const cHora = getTimeStamp(currDate);

        if (info instanceof Object && info.length > 0) {
          const rowItems = info.map(row => {
            return createData(row);
          });
          const footerItems = footerInfo.map(row => {
            return createFooterData(row);
          });
          setFilteredItems(rowItems);
          setFooterData(footerItems);
          setCurrentDate(
            `Fecha: ${cDate} | Hora: ${cHora}`,
          );
          setDataEmpty(false);
        } else {
          setFilteredItems([]);
          setFooterData([]);
          setDataEmpty(true);
        }
      });
  };

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Typography
              component="h2"
              variant="h6"
              color="primary"
              gutterBottom
            >
              Resultados Conteo Convención por JRV
            </Typography>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
            >
              {formik => (
                <>
                  {renderForm()}
                  <Grid container spacing={0}>
                    <Grid
                      item
                      xs={12}
                      style={{ textAlign: 'right' }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={doSearch(formik.values)}
                        style={{ marginTop: 10 }}
                      >
                        Consultar
                      </Button>
                    </Grid>
                  </Grid>
                </>
              )}
            </Formik>
            {showResults &&
              (!isLoading ? (
                <MacroList
                  dataEmpty={isDataEmpty}
                  sumTotalsColumns
                  listName={currentDate}
                  uiStylesClasses={classes}
                  btnConfig={{
                    name: 'Imprimir',
                    event: () => window.print(),
                  }}
                  actionConfig={setActions}
                  tableHeads={heads}
                  tableBody={filteredItems}
                  tableFooter={footerData}
                  displayCopyright={false}
                  isCrudAvailable
                />
              ) : (
                <Grid container spacing={0}>
                  <Grid
                    item
                    xs={12}
                    style={{ textAlign: 'center' }}
                  >
                    <CircularProgress
                      style={{
                        width: '28px',
                        height: '24px',
                      }}
                    />
                  </Grid>
                </Grid>
              ))}
          </Paper>
        </Grid>
      </Grid>

      <Box pt={4}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default EVConvencionInterna;
